//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import { checkBreakpoint, defaultBlockProps } from "~/helpers";

export default {
    name: "BowCover",
    props: {
        ...defaultBlockProps,
    },

    data: () => ({
        checkBreakpointUpLg: false,
        checkBreakpointDownLg: false,
        video: null,
    }),

    fetch() {
        if (this.media && this.media.length > 0) {
            if (this.media[0].type === "video") {
                this.video = {
                    url: this.media[0].url,
                    provider: "wordpress",
                };
            }
        }
    },

    computed: {
        ...mapState({
            info: ({ immobile }) => immobile.info,
        }),

        ...mapGetters(["immobile/getInfo"]),
    },

    mounted() {
        this.checkBreakpointUpLg = checkBreakpoint.up("lg");
        this.checkBreakpointDownLg = checkBreakpoint.down("lg");
    },
};
